import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { EMAIL, PRODUCTS, PRODUCT_SLUGS, scrollToId, trackEvent, waLink, WA_DISPLAY } from "@/lib/vgt";

const goToQuote = () => {
  if (document.getElementById("quotation")) scrollToId("quotation");
  else window.location.href = "/#quotation";
};

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#1C120C] text-[#FAF6EE]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-16 pb-10">
      <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-[#3D2B1E]">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/images/vgt-logo.jpg"
              alt="Vanilla Global Transindo logo"
              className="w-12 h-12 rounded-full object-cover ring-1 ring-[#3D2B1E] shadow-sm"
            />
            <span className="font-serif font-bold text-lg">Vanilla Global Transindo</span>
          </div>
          <p className="mt-4 font-serif italic text-[#D4A359] text-lg">
            Premium Indonesian vanilla, direct to global B2B buyers.
          </p>
          <p className="mt-3 text-sm text-[#FAF6EE]/60 leading-relaxed max-w-md">
            Indonesian vanilla beans exporter supplying food manufacturers, bakeries, gelato and chocolate
            makers, importers, and distributors worldwide.
          </p>
          <button
            data-testid="footer-cta-quote-button"
            onClick={goToQuote}
            className="group mt-6 inline-flex items-center gap-2 bg-[#D4A359] hover:bg-[#c2924a] text-[#1C120C] text-sm font-bold rounded-full px-6 py-3 transition-colors"
          >
            Request a Quotation
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
          </button>
        </div>
        <div className="md:justify-self-center">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#D4A359] mb-5">Our Products</p>
          <ul className="space-y-3.5 text-sm">
            {PRODUCTS.map((p) => (
              <li key={p.id}>
                <Link
                  data-testid={`footer-product-link-${p.id}`}
                  to={`/products/${PRODUCT_SLUGS[p.id]}`}
                  className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors"
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:justify-self-end">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#D4A359] mb-5">Contact & Links</p>
          <ul className="space-y-3.5 text-sm">
            <li>
              <a data-testid="footer-link-website" href="/indonesian-vanilla-supplier" className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors">
                Website — vanillaglobaltransindo.com
              </a>
            </li>
            <li>
              <a
                data-testid="footer-link-whatsapp"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("whatsapp_click", { location: "footer" })}
                className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors"
              >
                WhatsApp — {WA_DISPLAY}
              </a>
            </li>
            <li>
              <a data-testid="footer-link-email" href={`mailto:${EMAIL}`} className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors">
                Email — {EMAIL}
              </a>
            </li>
            <li>
              <a data-testid="footer-link-privacy" href="/privacy" className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors">
                Privacy Policy
              </a>
            </li>
            <li>
              <a data-testid="footer-link-terms" href="/terms" className="text-[#FAF6EE]/80 hover:text-[#D4A359] transition-colors">
                Terms &amp; Conditions
              </a>
            </li>
          </ul>
        </div>
      </div>
      <p className="pt-8 text-xs text-[#FAF6EE]/40 tracking-wide">
        © 2026 Vanilla Global Transindo (VGT). Indonesian vanilla supplier & exporter. All rights reserved.
      </p>
    </div>
  </footer>
);
